<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<div class="evaluation-info-container">
  <div class="toolbar-group move-group">
    @if (selectedEvaluationId && displayedMoveNumber > -1) {
    <button aria-label="Decrement Displayed Move" mat-icon-button [disabled]="isMinMoveNumber"
      (click)="decrementDisplayedMove()" title="Previous Move">
      <mat-icon class="icon-color" fontIcon="mdi-chevron-left"></mat-icon>
    </button>
    <span class="move-label">Move <span [ngStyle]="getMoveStyle()">{{ displayedMoveNumber }}</span> of {{
      getMaxMoveNumber() }}</span>
    <button aria-label="Increment Displayed Move" mat-icon-button [disabled]="isCurrentMoveNumber"
      (click)="incrementDisplayedMove()" title="Next Move">
      <mat-icon class="icon-color" fontIcon="mdi-chevron-right"></mat-icon>
    </button>
    @if (showAdvanceMoveButton) {
    <button aria-label="Advance Move" mat-flat-button (click)="advanceCurrentMove()" class="advance-button"
      title="Advance the evaluation to the next move for all participants" [disabled]="noChanges">
      Advance Move
    </button>
    }
    }
  </div>
  @if (selectedEvaluationId) {
  <div class="evaluation-name" [title]="getEvaluationDescriptionById(selectedEvaluationId)">
    {{ getEvaluationDescriptionById(selectedEvaluationId) }}
  </div>
  }
  @if (selectedEvaluationId && selectedTeamId) {
  <div class="toolbar-group right-buttons">
    <span class="team-label">{{ selectedTeamId === myTeamId ? 'Team:' : 'Observing:' }}</span>
    @if (teamList && teamList.length <= 1) {
    <b>{{ getTeamShortName() }}</b>
    }
    @if (teamList && teamList.length > 1) {
    <button mat-button class="team-button" [matMenuTriggerFor]="teamMenu" title="Select a team">
      <b>{{ getSelectedTeamShortName() }}</b>
      <mat-icon iconPositionEnd fontIcon="mdi-chevron-down"></mat-icon>
    </button>
    <mat-menu #teamMenu="matMenu" [overlapTrigger]="false">
      @for (team of teamList; track team.id) {
      <button mat-menu-item (click)="setActiveTeam(team.id)">
        {{ team.shortName }}
      </button>
      }
    </mat-menu>
    }
    @if (selectedSection !== dashboardSection) {
    <button mat-icon-button style="outline: none;" title="Dashboard" (click)="setSection(dashboardSection)">
      <mat-icon class="mdi-24px" fontIcon="mdi-view-dashboard"></mat-icon>
    </button>
    }
    @if (selectedSection !== scoresheetSection && !hideScoresheet()) {
    <button mat-icon-button style="outline: none;" title="Scoresheet" (click)="setSection(scoresheetSection)">
      <mat-icon class="mdi-24px" fontIcon="mdi-grid"></mat-icon>
    </button>
    }
    @if (selectedSection !== reportSection) {
    <button mat-icon-button style="outline: none;" title="SubmissionReview" (click)="setSection(reportSection)">
      <mat-icon class="mdi-24px" fontIcon="mdi-file-document-outline"></mat-icon>
    </button>
    }
    @if (showAdminButton && selectedSection !== aggregateSection) {
    <button mat-icon-button style="outline: none;" title="Aggregate Report" (click)="setSection(aggregateSection)">
      <mat-icon class="mdi-24px" fontIcon="mdi-file-document-multiple-outline"></mat-icon>
    </button>
    }
    @if (showAdminButton) {
    <button aria-label="Show Administration Page" mat-icon-button [routerLink]="['/admin']"
      [queryParams]="{section: 'Evaluations'}" style="outline: none;" title="Administration">
      <mat-icon class="mdi-24px" fontIcon="mdi-cog"></mat-icon>
    </button>
    }
  </div>
  }
</div>
